// src/redux/reducers/staffManagementReducer.js

import { combineReducers } from "redux";

import timeSheetSlice from "../slice/staff-management/time-sheet-slice";
import leavesSlice from "../slice/staff-management/staff-leave-slice";
import attendanceSlice from "../slice/staff-management/staff-attendance";

const staffManagementReducer = combineReducers({
  timeSheet: timeSheetSlice,
  leaves: leavesSlice,
  attendance: attendanceSlice,
});

export default staffManagementReducer;
